<template>
  <div class="c-visitor-form">
        <div class="form-row">
            <label for="email">{{$t('generic.email')}}</label>
            <div class="form-row--field">
                <input type="email" class="inputfield" :class="{error:formErrors.email}" autocomplete="off" v-model="getClient.email" tabindex="1">
            </div>
        </div>

        <div class="form-row">
            <label for="lastname">{{$t('generic.lastname')}}</label>
            <div class="form-row--field">
                <input type="text" class="inputfield" :class="{error:formErrors.lastname}" autocomplete="off" v-model="getClient.lastname" tabindex="2">
            </div>
        </div>

        <div class="form-row">
            <label for="firstname">{{$t('generic.firstname')}}</label>
            <div class="form-row--field">
                <input type="text" class="inputfield" :class="{error:formErrors.firstname}" autocomplete="off" v-model="getClient.firstname" tabindex="3">
            </div>
        </div>

        <!-- div class="form-row">
            <label for="city">{{$t('client_form.country')}}</label>
            <div class="form-row--field">
                <InputSelect v-model:value="country" :options="countries"
                    :tabindex="4"
                    :editable="false" class="country"/>

                <<InputSelect v-model:value="getClient.additional_info.postal" :options="postalPrefills"
                    :tabindex="5"
                    :editable="true" class="postalcode"/>

                <input type="text" class="inputfield margin-left" autocomplete="off" v-model="getClient.additional_info.city" tabindex="5">
                <button class="btn-copy-address" @click.prevent="copyAddress()" v-if="showCopyAddress">
                    <img src="/img/icon-copy.svg" />
                </button>
            </div>
        </div>-->

        <!-- <div class="form-row street">
            <label for="street">{{$t('client_form.street')}}: </label>
            <div class="form-row--field">
                <InputSelect v-model:value="getClient.additional_info.street" :options="streetPrefills"
                    :tabindex="8"
                    :editable="true" class="street"/>

                <input type="text" class="inputfield small" autocomplete="off" v-model="getClient.additional_info.number" tabindex="7">
            </div>
        </div> -->

        <div class="form-row">
            <label for="tel">{{$t('client_form.tel')}}</label>
            <div class="form-row--field">
                <input type="text" class="inputfield" autocomplete="off" v-model="getClient.additional_info.tel" tabindex="9">
            </div>
        </div>

        <div class="form-row">
            <label for="tel">{{$t('client_form.bday')}}</label>
            <div class="form-row--field">
                <InputDate v-model:date="getClient.additional_info.bday" :tabindex="10"/>
            </div>
        </div>

        <div class="form-row">
            <label for="gdpr"></label>
            <div class="form-row--field">
                <Checkbox :class="{'gdpr-error' : formErrors.gdpr}" v-model:checked="getClient.additional_info.gdpr" :label="$t('client_form.gdpr_label')"/>
                <ClientFormInfoButton :popupText="$t('client_form.gdpr_text')"/>
            </div>
        </div>

        <div class="form-row">
            <label for="optin"></label>
            <div class="form-row--field">
                <Checkbox v-model:checked="getClient.additional_info.optin" :label="$t('client_form.optin_label')"/>
                <ClientFormInfoButton :popupText="$t('client_form.optin_text')"/>
            </div>
        </div>
  </div>
</template>

<script>
import InputDate from "@/components/InputDate.vue";
// import InputSelect from "@/components/InputSelect.vue";
import Checkbox from "@/components/Checkbox.vue";
import ClientFormInfoButton from "@/components/appointments/ClientFormInfoButton.vue";
import localforage from "localforage";
import {apiStore} from "@/stores/api";

export default {
    name: "ClientForm",
    components : {InputDate, /*InputSelect,*/ Checkbox, ClientFormInfoButton},

    data() {
        return {
            postalPrefills : [],
            streetPrefills : [],
            countryCodes : ["be", "nl", "fr", "de", "lu", "at"],
            countries: [],
            country: "be"
        };
    },

    props: {
        client : {required : false, type : Object},
        formErrors : {type:Object},
        showCopyAddress : {type:Boolean, default:false}
    },

    async created() {
        let cachedCountryCode = await localforage.getItem("country");
        if (cachedCountryCode === null) {
            cachedCountryCode = this.countryCodes[0];
        }
        this.country = this.$t(`countries.${cachedCountryCode}`);

        for (const country of this.countryCodes) {
            this.countries.push(this.$t(`countries.${country}`));
        }
    },

    computed: {
        countryCode() {
            return this.countryCodes[this.countries.indexOf(this.country)];
        },

        getClient: {
            get() {
                return this.client;
            },
            set(value) {
                this.$emit("update:client", value);
            }
        }
    },

    watch: {
        "client.additional_info.postal" : {
            immediate: true,
            deep: true,
            async handler(newValue) {
                if (!newValue) return;
                if (newValue.length > 8) {
                    // user clicked on a prefilled value
                    const data = newValue.split(" ");
                    // eslint-disable-next-line vue/no-mutating-props
                    this.client.additional_info.postal = data[0];
                    data.shift();
                    // eslint-disable-next-line vue/no-mutating-props
                    this.client.additional_info.city = data.join(" ");
                } else {
                    this.fetchPostalCodes();
                }
            }
        },

        "client.additional_info.street" : {
            immediate: true,
            deep: true,
            async handler(street) {
                if (street !== undefined && street.length > 0) {
                    this.streetPrefills = await apiStore().searchStreet(this.countryCode, this.client.additional_info.postal, street);
                }
            }
        },

        "$i18n.locale"() {
            this.countries = [];
            for (const country of this.countryCodes) {
                this.countries.push(this.$t(`countries.${country}`));
            }
        },

        country() {
            localforage.setItem("country", this.countryCode);
            this.fetchPostalCodes();
        }
    },

    methods: {
        async fetchPostalCodes() {
            const postalCode = this.client.additional_info.postal;
            if (postalCode && postalCode.trim() !== "") {
                const postalCodes = await apiStore().searchPostalCodes(this.countryCode, postalCode);
                this.postalPrefills = postalCodes.map(p => p.postalcode + " " + p.city);
            }
        },

        copyAddress() {
            this.$emit("copyaddress");
        }
    }
};
</script>

<style scoped lang="scss">
.c-visitor-form {
    width: 100%;
    margin: auto;
    margin-top: .5rem;

    .form-row {
        display: flex;
        align-items: center;
        position: relative;
        &.street {
            z-index: 1;
        }

        label {
            font-weight: bold;
            width : 35%;
            display : block;
            text-align: right;
            padding-bottom: 1rem;
            font-size: 1.25rem;
        }

        &--field {
            width: 65%;
            display: flex;
            padding-left: 2rem;

            .inputfield {
                height : 2.8rem;
                width : 100%;

                &.inputfield-50 {
                    width : 50%;
                }

                &.small {
                    width : 25%;
                }

                &.margin-left {
                    margin-left: 1em;
                }

                &.margin-right {
                    margin-right: 1em;
                }
            }
        }

        .c-input-select {
               height: 2.8rem;
        }

        .street {
            margin-right: 1rem;
            :deep(.options) {
                margin-left : -1rem;
            }
            :deep(.option) {
                text-align: left;
                padding-left : 1rem;
            }
        }

        .country {
            width : 47%;
            margin-right: 1rem;
            text-align: left;

            :deep(.value) {
                text-align: left;
            }

            :deep(.options) {
                width : 150%;

                .option {
                    text-align: left;
                    padding-left : 1rem;
                }
            }
        }

        .postalcode {
            width : 32%;

            :deep(.options) {
                width : 250%;

                .option {
                    text-align: left;
                    padding-left : 1rem;
                }
            }
        }

        .btn-copy-address {
            @extend .btn-round;
            position: absolute;
            background : #1F1F1F;
            right : 0;
            right: -3rem;
            top: .5rem;
        }
    }

    .gdpr-error {
        border : solid .1rem $color-red;
        padding: 0.5rem;
        margin: -0.5rem;
        margin-right: 0.3rem;
    }

    :deep(.c-checkbox) {
        margin-bottom : .65rem;
    }
}

</style>
